import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

export const query = gql`
  mutation MergeSuperchargerFreeMember($gameId: Int!, $phoneNumber: String!) {
    mergeSuperchargerFreeMember(gameId: $gameId, phoneNumber: $phoneNumber) {
      id
      status
    }
  }
`;

// Merges the free member holding this number in this game into the account
// that just signed in or signed up on the pay flow's account step
// (GlpWonSignup; account merge v2, 2026-10-25). notify runs it inside the
// request: { id, status: 'done' }, or a notify_service_* error.
export function useMergeSuperchargerFreeMember() {
  const [mutate, { loading, error }] = useMutation(query);

  const mergeSuperchargerFreeMember = ({ gameId, phoneNumber }) =>
    mutate({ variables: { gameId, phoneNumber } });

  return { mergeSuperchargerFreeMember, loading, error };
}
